import React, { useState, useEffect } from "react";
import { Button, TextField, InputAdornment, IconButton } from "@mui/material";
import { message } from "antd";

import { useNavigate } from "react-router-dom";
import { auth, setDoc, db, doc, getDoc } from "../../firebase";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import "./Register.css";
import { Toast } from "bootstrap";
const Register = () => {
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    email:"",
    username: "",
    reUsername: "",
    password: "",
    rePassword: "",
    loginCode: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);
  const [usernameExists, setUsernameExists] = useState(false);

  const navigate = useNavigate();

  // Password validation conditions
  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{6,}$/;
    return passwordRegex.test(password);
  };

  useEffect(() => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        "recaptcha-container",
        {
          size: "normal",
          callback: function (response) {
            // User successfully solved the reCAPTCHA, you can hide the container here
            document.getElementById("recaptcha-container").style.display =
              "none";
            Toast("Captcha verified successfully!");
          },
          "expired-callback": function () {
            // Response expired. Ask the user to solve the reCAPTCHA again.
            document.getElementById("recaptcha-container").style.display =
              "block";
            alert("Captcha expired, please try again.");
          },
        }
      );
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Check if the field is firstName, middleName, or lastName
    const updatedValue =
      name === "firstName" || name === "middleName" || name === "lastName"
        ? value.toUpperCase() // Convert to uppercase
        : value;

    setFormData((prevData) => ({
      ...prevData,
      [name]: updatedValue,
    }));
  };

  const sentOtp = async () => {
    if (!phone || phone.length < 10) {
      message.error("Enter a valid mobile number");
      return;
    }

    const formattedPhone = phone.startsWith("+91") ? phone : `+91${phone}`;

    if (!/^\+[1-9]\d{1,14}$/.test(formattedPhone)) {
      message.error("Invalid phone number format.");
      return;
    }

    try {
      const appVerifier = window.recaptchaVerifier;

      await signInWithPhoneNumber(auth, formattedPhone, appVerifier)
        .then((confirmationResult) => {
          setConfirmationResult(confirmationResult);
          message.success("OTP sent successfully");
        })
        .catch((error) => {
          console.error("Error during OTP send: ", error);
          message.error("Error sending OTP. Please try again later.");
        });
    } catch (error) {
      console.log("OTP Send Error: ", error);
      message.error("Failed to send OTP. Ensure phone number is correct.");
    }
  };

  const verifyOtp = () => {
    if (!otp) {
      message.error("Please enter the OTP");
      return;
    }

    if (confirmationResult) {
      confirmationResult
        .confirm(otp)
        .then((result) => {
          message.success("OTP verified successfully");
          localStorage.setItem("userPhone", phone);
          localStorage.setItem("userInfo", JSON.stringify(formData));
          setStep(2); // Move to the second step
        })
        .catch((error) => {
          console.error("Error during OTP verification: ", error);
          message.error("Error verifying OTP. Please try again.");
        });
    } else {
      message.error("Please request an OTP first.");
    }
  };

  const handleUsernameBlur = async (e) => {
    const username = e.target.value.trim();
    if (username) {
      try {
        const userDoc = doc(db, "users", username);
        const docSnap = await getDoc(userDoc);
        if (docSnap.exists()) {
          setUsernameExists(true);
          message.error("Username already exists");
        } else {
          setUsernameExists(false);
        }
      } catch (error) {
        console.error("Error checking username: ", error);
        message.error("Error checking username availability.");
      }
    }
  };

  const handleSubmit = async () => {
    if (formData.password !== formData.rePassword) {
      message.error("Passwords do not match");
      return;
    }

    if (formData.username !== formData.reUsername) {
      message.error("Usernames do not match");
      return;
    }

    if (!validatePassword(formData.password)) {
      message.error(
        "Password must contain at least one uppercase letter, one special character, and be at least 6 characters long"
      );
      return;
    }

    try {
      const userDoc = doc(db, "users", formData.username);
      await setDoc(userDoc, {
        ...formData,
        phone,
      });

      message.success("Registration successful");
      localStorage.setItem("username", formData.username);
      localStorage.setItem("password", formData.password);
      sendEmail(formData);
      navigate("/login");
    } catch (err) {
      console.error("Error during registration: ", err);
      message.error("Something went wrong during registration.");
    }
  };
  const sendEmail = async (formData) => {
    // Check if the email, username, and password are present in formData
    if (!formData.email || !formData.username || !formData.password) {
      console.error('Missing required fields: email, username, or password');
      
      return null;
    }
  
    // Validate the email format using a regular expression
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(formData.email)) {
      console.error('Invalid email format');
 
      return null;
    }
  
    const subject = "Your Credentials for gpaichalkaranji.com";
    const text = `Username: ${formData.username} \nPassword: ${formData.password} \n\n\n"Thank you for signing up with us. "`;
  
    try {
      const response = await fetch("https://gpa-backend-1x73.onrender.com/api/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          recipientEmail: formData.email, // Ensure this is being passed correctly
          subject,
          text
        }),
      });
  
      if (!response.ok) {
        throw new Error('Failed to send email');
      }
  
      const data = await response.json();
      console.log('Email sent successfully', data);
     
      return data;
    } catch (error) {
      console.error('Error sending email:', error);
      
      return null;
    }
  };
  

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowRePassword = () => setShowRePassword((show) => !show);

  return (
    <div className="register-container">
      <div className="register-form">
        {step === 1 && (
          <form>
            <div className="form-header">
              <h3>REGISTRATION</h3>
            </div>
            <TextField
              className="custom-textfield"
              name="firstName"
              label="First Name"
              value={formData.firstName}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              className="custom-textfield"
              name="middleName"
              label="Middle Name"
              value={formData.middleName}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              className="custom-textfield"
              name="lastName"
              label="Last Name"
              value={formData.lastName}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              className="custom-textfield"
              name="email"
              label="Email"
              value={formData.email}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />

            <TextField
              className="custom-textfield"
              label="Phone Number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              fullWidth
              margin="normal"
              maxlength="10"
              pattern="\d{10}"
              title="Please enter exactly 10 digits"
              required
            />
            <div id="recaptcha-container"></div>
            <div className="phone-signin-btn ">
              <br />
              <Button
                className="send-btn"
                variant="contained"
                onClick={sentOtp}
                disabled={confirmationResult}
              >
                Send OTP
              </Button>
            </div>
            {confirmationResult && (
              <div className="otp-verification">
                <TextField
                  // className="custom-textfield"
                  label="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  fullWidth
                  margin="normal"
                  required
                />
                <Button
                  variant="contained"
                  color="primary"
                  className="send-btn"
                  onClick={verifyOtp}
                >
                  Verify OTP
                </Button>
              </div>
            )}
          </form>
        )}
        {step === 2 && (
          <form>
            <div className="form-header">
              <h3>Registration</h3>
            </div>
            <TextField
              className="custom-textfield"
              name="username"
              label="Create Username"
              value={formData.username}
              onChange={handleChange}
              onBlur={handleUsernameBlur}
              fullWidth
              margin="normal"
              required
              error={usernameExists}
              helperText={usernameExists ? "Username exists" : ""}
            />
            <TextField
              className="custom-textfield"
              name="reUsername"
              label="Re-enter Username"
              value={formData.reUsername}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              className="custom-textfield"
              name="password"
              label="Create Password"
              type={showPassword ? "text" : "password"}
              value={formData.password}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              className="custom-textfield"
              name="rePassword"
              label="Re-enter Password"
              type={showRePassword ? "text" : "password"}
              value={formData.rePassword}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowRePassword}
                    >
                      {showRePassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              className="buttons"
              sx={{ backgroundColor: "#333333", color: "white" }}
              variant="contained"
              fullWidth
              onClick={handleSubmit}
            >
              Register
            </Button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Register;
